import { render, staticRenderFns } from "./RegisterStep.vue?vue&type=template&id=e51b8fa4&scoped=true"
import script from "./RegisterStep.vue?vue&type=script&lang=js"
export * from "./RegisterStep.vue?vue&type=script&lang=js"
import style0 from "./RegisterStep.vue?vue&type=style&index=0&id=e51b8fa4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51b8fa4",
  null
  
)

export default component.exports